import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav className="navbar" aria-label="Main navigation">
      <div className="navbar-inner">
        <Link to="/" className="logo-link">
          <img src={logo} alt="CarEx Logo" className="logo-image" />
        </Link>
        <button
          type="button"
          className="nav-toggle"
          aria-expanded={menuOpen}
          aria-controls="primary-navigation"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className="nav-toggle-box" aria-hidden>
            <span className={`nav-toggle-bar ${menuOpen ? 'nav-toggle-bar--open' : ''}`} />
          </span>
        </button>
        <div
          id="primary-navigation"
          className={`nav-links ${menuOpen ? 'nav-links--open' : ''}`}
        >
          <Link to="/" onClick={() => setMenuOpen(false)}>
            Home
          </Link>
          <Link to="/privacy-policy" onClick={() => setMenuOpen(false)}>
            Privacy Policy
          </Link>
          <Link to="/terms" onClick={() => setMenuOpen(false)}>
            Terms
          </Link>
          <Link to="/support" onClick={() => setMenuOpen(false)}>
            Support
          </Link>
          <Link to="/marketplace-policies" onClick={() => setMenuOpen(false)}>
            Policies
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
